const alljournalentry = { data: [], loading: true };
export const GetAllJournalEntry = (state = alljournalentry, action) => {
    switch (action.type) {

        case "get_alljournalentry":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}
